import anime from 'animejs'

export function tweenNumbers(number) {
    const timeline = anime.timeline()
    const obj = { value: 0 }
    const finalValue = number.number

    return anime({
        targets: obj,
        value: [0, finalValue],
        duration: 1500,
        easing: 'easeOutQuart',
        update: () => requestAnimationFrame(() => { number.number = Math.round(obj.value) })
    }).finished
}


// WEBPACK FOOTER //
// ./app/theme/components/numbers/numbers-tweens.js